import React, { useEffect, useRef } from 'react'
import Icon from '../../design/icons'
import { useContent } from '../../content/ContentProvider'

let modalIdCounter = 0

const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'

export function Modal({ isOpen, title, onClose, children, size = 'md' }) {
  const { t } = useContent()
  const panelRef = useRef(null)
  const titleId = useRef(`modal-title-${++modalIdCounter}`).current

  useEffect(() => {
    if (!isOpen) return

    const previouslyFocused = document.activeElement
    const panel = panelRef.current
    const getFocusable = () => (panel ? Array.from(panel.querySelectorAll(FOCUSABLE_SELECTOR)) : [])

    const focusable = getFocusable()
    ;(focusable[0] || panel)?.focus()

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation()
        onClose()
        return
      }
      if (e.key !== 'Tab') return
      const items = getFocusable()
      if (items.length === 0) return
      const first = items[0]
      const last = items[items.length - 1]
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault()
        last.focus()
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault()
        first.focus()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      previouslyFocused?.focus?.()
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        ref={panelRef}
        className={`modal modal--${size}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal__head">
          <div className="modal__title" id={titleId} style={{ flex: 1 }}>
            {title}
          </div>
          <button type="button" className="iconbtn" onClick={onClose} aria-label={t('modal.close')}>
            {Icon.close({ s: 16 })}
          </button>
        </div>
        <div className="modal__body">{children}</div>
      </div>
    </div>
  )
}
